(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    
  function applyFormsThemeStyle(host) {
    var root = host.shadowRoot;
    if (!root) {
      return;
    }

    var existing = root.querySelector('[data-theme-override]');
    var styleTags = root.querySelectorAll('style');
    var lastStyleTag = styleTags[styleTags.length - 1];

    if (existing) {
      // The component can re-render its own <style> tag after ours has been
      // injected (e.g. on a step change), which pushes ours out of last
      // place and loses it the cascade tie-break. Re-append to reclaim it.
      if (lastStyleTag !== existing) {
        root.appendChild(existing);
      }
      return;
    }

    var style = document.createElement('style');
    style.setAttribute('data-theme-override', 'true');
    style.textContent = `
      :host {
        --forms-accent-color: var(--color-primary);
        --forms-accent-color-hovered-modifier: var(--color-primary-hover);

        --forms-base-font-size: 18px;
        --forms-body-font: var(--font-body--weight) var(--font-body--style) var(--forms-base-font-size) var(--font-body--family);
        --forms-heading-font: var(--font-h3--weight) var(--font-h3--style) var(--forms-heading-font-size) var(--font-h3--family);

        --body-text-color: var(--color-foreground);
        --heading-text-color: var(--color-foreground-heading);
        --link-text-color: var(--color-primary);
        --form-text-color: var(--color-foreground);
        --form-placeholder-color: var(--color-input-text);
        --form-background-color: var(--color-input-background);

        --button-text-color: var(--color-primary-button-text);
        --button-background-color: var(--color-primary-button-background);
        --button-background-color-hovered-modifier: var(--color-primary-button-hover-background);

        --form-field-border: 0 0 0 var(--style-border-width-inputs) var(--color-input-border);
        --form-field-border-focused: 0 0 0 calc(var(--style-border-width-inputs) * 2) var(--color-primary);
        --form-field-border-radius: 0;
        --button-border-radius: 0;
        --form-field-padding-top: calc(var(--form-field-padding) * 1.75);
      }

      label[for],
      [class*="_formFileInput_"] > p {
        color: #404040 !important;
        cursor: pointer !important;
        font-family: "Futura PT", "system_ui", -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
        font-size: 18px !important;
        font-style: normal !important;
        font-variation-settings: "slnt" 0 !important;
        font-weight: 600 !important;
        text-transform: uppercase !important;
      }

      label[for] {
        top: 19.5px !important;
      }

      /* Match the page's actual h2 styling instead of the component's own
         small, non-uppercase default heading, but yellow and heavier. */
      [class*="_textHeading_"] {
        font-family: var(--font-h2--family) !important;
        font-style: var(--font-h2--style) !important;
        font-weight: 600 !important;
        font-size: var(--font-h2--size) !important;
        line-height: var(--font-h2--line-height) !important;
        letter-spacing: var(--font-h2--letter-spacing) !important;
        text-transform: var(--font-h2--case) !important;
        color: rgb(235, 220, 25) !important;
      }

      [data-testid="btn-form-submit"],
      [class*="_formFileInputButton"] {
        text-transform: uppercase !important;
      }

      [class*="_formFileInputButton"] {
        background-color: transparent !important;
      }

      /* The component doesn't actually wire padding-top or border-radius on
         the input to their custom properties, so set them directly. Inputs
         should always be square, never rounded. */
      [class*="_formInputField_"],
      [class*="_formPhoneInputField_"] {
        padding-top: calc(var(--form-field-padding) * 1.75) !important;
        border-radius: 0 !important;
      }

      /* Let the country selector stretch to match the text input's height
         in the phone number row instead of matching its padding formula
         (the selector's own padding should stay as designed). */
      [class*="_selectContainer_"],
      [class*="_selectToggle_"] {
        height: 100% !important;
        max-height: none !important;
      }

      [role="option"] {
        color: #FFFFFF !important;
        text-transform: uppercase !important;
        border-radius: 0 !important;
      }

      [role="option"]:hover,
      [role="option"][aria-selected="true"] {
        color: #000000 !important;
      }
    `;
    root.appendChild(style);
  }

  function shadowHasRenderedContent(root) {
    return !!root && !!root.querySelector('form, [data-testid="app-router"]');
  }

  function watchFormsEmbed(host) {
    if (host.dataset.themeStyleWatched === 'true') {
      return;
    }
    host.dataset.themeStyleWatched = 'true';

    var tryApply = function () {
      if (shadowHasRenderedContent(host.shadowRoot)) {
        applyFormsThemeStyle(host);
      }
    };

    var retriesLeft = 50;
    var waitForShadowRoot = setInterval(function () {
      if (host.shadowRoot) {
        clearInterval(waitForShadowRoot);
        new MutationObserver(tryApply).observe(host.shadowRoot, {
          childList: true,
          subtree: true,
        });
        tryApply();
        return;
      }
      retriesLeft -= 1;
      if (retriesLeft <= 0) {
        clearInterval(waitForShadowRoot);
      }
    }, 100);
  }

  function findFormsEmbeds() {
    document.querySelectorAll('shopify-forms-embed').forEach(watchFormsEmbed);
  }

  function startWatchingBody() {
    findFormsEmbeds();
    new MutationObserver(findFormsEmbeds).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.body) {
    startWatchingBody();
  } else {
    document.addEventListener('DOMContentLoaded', startWatchingBody);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const carousels = document.querySelectorAll('[data-section-id]');

    carousels.forEach(function (carouselElement) {
      const sliderWrappers = carouselElement.querySelectorAll('.collection-carousel__slider-wrapper');
      
      if (sliderWrappers.length === 0) return;

      const limitProducts = sliderWrappers[0].querySelector('.collection-carousel__products-swiper').getAttribute('data-limit-products') === 'true';
      const slidesPerView = parseInt(sliderWrappers[0].querySelector('.collection-carousel__products-swiper').getAttribute('data-slides-per-view')) || 3;
      const autoplay = sliderWrappers[0].querySelector('.collection-carousel__products-swiper').getAttribute('data-autoplay') === 'true';
      const autoplayDelay = parseInt(sliderWrappers[0].querySelector('.collection-carousel__products-swiper').getAttribute('data-autoplay-delay')) || 5000;

      let productsSwiperInstances = {};
      let currentCollectionIndex = 0;

      // Initialize product swipers for each collection
      sliderWrappers.forEach(function (wrapper, index) {
        const productsSwiper = wrapper.querySelector('.collection-carousel__products-swiper');
        
        if (limitProducts) {
          productsSwiperInstances[index] = new Swiper(productsSwiper, {
            slidesPerView: slidesPerView,
            spaceBetween: 24,
            loop: false,
            autoplay: autoplay ? { delay: autoplayDelay, disableOnInteraction: true } : false,
            navigation: {
              nextEl: carouselElement.querySelector('.collection-carousel__products-next'),
              prevEl: carouselElement.querySelector('.collection-carousel__products-prev'),
            },
            pagination: {
              el: productsSwiper.querySelector('.collection-carousel__pagination'),
              clickable: true,
              dynamicBullets: true,
            },
            breakpoints: {
              320: {
                slidesPerView: 1,
                spaceBetween: 12,
              },
              640: {
                slidesPerView: Math.min(2, slidesPerView),
                spaceBetween: 16,
              },
              1024: {
                slidesPerView: Math.min(slidesPerView, 3),
                spaceBetween: 20,
              },
              1025: {
                slidesPerView: slidesPerView,
                spaceBetween: 24,
              },
            },
          });
        }
      });

      // Initialize headers swiper
      const headersSwiper = new Swiper('.collection-carousel__headers-swiper', {
        slidesPerView: 'auto',
        spaceBetween: 32,
        loop: false,
        allowTouchMove: true,
        freeMode: false,
        speed: 300,
      });

      // Handle header title clicks
      const headerTitles = carouselElement.querySelectorAll('.collection-carousel__title');

      headerTitles.forEach(function (title) {
        title.addEventListener('click', function () {
          const collectionIndex = parseInt(this.getAttribute('data-collection-index'));
          
          if (collectionIndex === currentCollectionIndex) return;

          // Update active header title
          headerTitles.forEach(h => h.classList.remove('collection-carousel__title--active'));
          this.classList.add('collection-carousel__title--active');

          // Scroll headers to align active header to left
          headersSwiper.slideTo(collectionIndex, 300);

          // Hide current collection, show new one
          sliderWrappers.forEach(function (wrapper, index) {
            wrapper.classList.remove('collection-carousel__slider-wrapper--active');
          });
          sliderWrappers[collectionIndex].classList.add('collection-carousel__slider-wrapper--active');

          // Reinitialize swiper if needed
          if (limitProducts && productsSwiperInstances[collectionIndex]) {
            productsSwiperInstances[collectionIndex].slideTo(0, 300);
          }

          currentCollectionIndex = collectionIndex;
        });

        // Add keyboard support
        title.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.click();
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layered-media-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const revealLayers = document.querySelectorAll('.layered-hero__layer-media[data-scroll-reveal="true"]');

    if (!revealLayers.length) return;

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;

          entry.target.classList.add('is-visible');
          currentObserver.unobserve(entry.target);
        }
      },
      { threshold: 0.2 }
    );

    revealLayers.forEach((layer) => observer.observe(layer));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotify-playlists"] && !Shopify.designMode) return;
  try {
    
  const initSpotifyPlaylistsSection = (section) => {
    if (!section) return;

    const items = section.querySelectorAll('[data-playlist]');
    const player = section.querySelector('[data-spotify-player]');
    if (!items.length || !player) return;

    items.forEach((item) => {
      item.addEventListener('click', () => {
        const id = item.dataset.playlist;
        if (!id) return;
        player.src = `https://open.spotify.com/embed/playlist/${id}`;
      });
    });
  };

  const spotifySections = document.querySelectorAll('.spotify-playlists[data-section-id]');
  spotifySections.forEach((section) => initSpotifyPlaylistsSection(section));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator-map"] && !Shopify.designMode) return;
  try {
    
  function areMapDependenciesReady() {
    return(typeof window.L !== 'undefined' && typeof window.Fuse !== 'undefined' && typeof window.L.markerClusterGroup === 'function' && typeof window.L.maplibreGL === 'function' && typeof window.L.Control.Search !== 'undefined');
  }

  function initStoreLocatorMap() {
    var places = [];
    var wrapperElement = document.getElementById('store-locator-wrapper');
    var mapElement = document.getElementById('store-locator-map');
    var searchInput = document.getElementById('store-search-input');
    var searchResults = document.getElementById('store-search-results');

    if (! mapElement || ! wrapperElement) {
      return;
    }

    if (mapElement.dataset.initialized === 'true') {
      return;
    }
    mapElement.dataset.initialized = 'true';

    var markerIconUrl = wrapperElement
      ? wrapperElement.dataset.markerIconUrl
      : '';
    var styleUrl = wrapperElement
      ? wrapperElement.dataset.styleUrl
      : '';
    var csvUrl = wrapperElement
      ? wrapperElement.dataset.tsvUrl
      : '';
    var countryCode = wrapperElement
      ? wrapperElement.dataset.countryCode
      : 'US';
    var searchPlaceholder = wrapperElement
      ? wrapperElement.dataset.searchPlaceholder
      : 'Search stores or locations...';

    var fullscreenControlLocation = 'bottomright';

    var map = L.map('store-locator-map', {
      minZoom: 1,
      maxZoom: 18,
      zoomControl: false,
      gestureHandling: true,
      fullscreenControl: true,
      fullscreenControlOptions: {
        position: fullscreenControlLocation
      }
    }).locate({setView: true, maxZoom: 18});

    var redIcon = new L.Icon({
      iconUrl: markerIconUrl,
      iconSize: [19, 27],
      iconAnchor: [10, 27],
      popupAnchor: [0, -50],
      shadowSize: [0, 0]
    });

    L
      .control
      .locate()
      .setPosition('bottomright')
      .addTo(map);

    L
      .control
      .zoom()
      .setPosition('bottomright')
      .addTo(map);

    fetch(styleUrl).then((response) => response.json()).then((colorfulStyle) => {
      var gl = L.maplibreGL({style: colorfulStyle}).addTo(map);
    }).catch((error) => console.error('Error fetching map style:', error));

    var markers = L.markerClusterGroup({
      spiderfyOnMaxZoom: false,
      showCoverageOnHover: false,
      zoomToBoundsOnClick: true,
      iconCreateFunction: function(cluster) {
        return L.divIcon({
          html: '<b>' + cluster.getChildCount() + '</b>'
        });
      }
    });

    var markerbounds = [];
    map.addLayer(markers);

    var places = [];
    var defaultCenter = [
      parseFloat(
        countryCode === 'NZ'
          ? '-41.2865'
          : '37.0902'
      ),
      parseFloat(
        countryCode === 'NZ'
          ? '174.8860'
          : '-95.7129'
      )
    ];

    fetch(csvUrl).then((res) => res.text()).then((csvData) => {
      let rows = csvData.split('\n').slice(1);

      rows.forEach((row) => {
        let [
          name,
          address,
          rowCountryCode,
          lat,
          lng
        ] = row.split('\t');

        if (lat && lng && (countryCode === '' || rowCountryCode.trim() === countryCode)) {
          let latNum = parseFloat(lat);
          let lngNum = parseFloat(lng);

          const uniqueId = `${name} ${address}`;

          let marker = L.marker([latNum, lngNum], {icon: redIcon});
          markerbounds.push(marker);

          marker.feature = {
            properties: {
              name: name,
              address: address,
              uniqueId: uniqueId
            }
          };

          marker.bindPopup(`<strong>${name}</strong><br>${address}<br><a href="http://maps.google.com/?q=${name} ${address}" target="_blank">View on Google Maps</a><br>`);
          marker.addTo(markers);

          places.push({name: name, address: address, uniqueId: uniqueId, marker: marker});
        }
      });

      var group = L.featureGroup(markerbounds);

// Check if we have markers before trying to fit bounds
      if (markerbounds.length > 0) {
        try {
          map.fitBounds(group.getBounds());
        } catch (e) {
          console.error('Error fitting bounds to markers:', e);
          map.setView(defaultCenter, 4);
        }
      } else {
        console.warn('No stores found matching the country code filter:', countryCode);
        map.setView(defaultCenter, 4);
      }

      var fuse = new Fuse(places, {
        keys: ['name', 'address'],
        threshold: 0.3,
        includeScore: true
      });

      var enableNominatimResults = true;

// Set to true to enable nominatim API results

// Display all locations on initial load
      function displayAllPlaces() {
        let allResults = {};
        places.forEach((place) => {
          allResults[place.uniqueId] = place.marker;
        });
        displaySearchResults(allResults);
      }

      function combinedSearch(text, callResponse) {
        console.log(text, callResponse);
        let results = {};

        var fuseResults = fuse.search(text);
        fuseResults.forEach((res) => {
          let item = res.item;
          results[item.uniqueId] = item.marker;
        });

        if (enableNominatimResults) {
          var nominatimUrl = `https://nominatim.openstreetmap.org/search?format=json&q=${
            encodeURIComponent(text)
          }`;
          fetch(nominatimUrl).then((res) => res.json()).then((data) => {
            data.forEach((loc, i) => {
              let key = loc.display_name;
              if (results[key]) {
                key = `${key} (${i})`;
              }
              let marker = L.marker([
                parseFloat(loc.lat),
                parseFloat(loc.lon)
              ], {icon: redIcon}).bindPopup(`<strong>${
                loc.display_name
              }</strong>`);
              marker.feature = {
                properties: {
                  name: loc.display_name,
                  address: loc.display_name,
                  uniqueId: key
                }
              };
              results[key] = marker;
            });
            console.log(results);
            callResponse(results);
          }).catch((err) => {
            console.error('Nominatim error:', err);
            callResponse(results);
          });
        } else {
          callResponse(results);
        }

        return {
          abort: function() {
            console.log('aborted request:' + text);
          }
        };
      }

// Handle sidebar search
      var currentResults = {};
      var selectedResultIndex = -1;

      function displaySearchResults(results) {
        searchResults.innerHTML = '';
        currentResults = results;
        selectedResultIndex = -1;

        Object.keys(results).forEach((key, index) => {
          const marker = results[key];
          const props = marker.feature ?. properties || {};
          const name = props.name || key;
          const icon = key.startsWith(name)
            ? 'area'
            : 'store';
          const address = props.address || '';

          const resultDiv = document.createElement('div');
          resultDiv.className = 'store-search-result';
          resultDiv.innerHTML = `<div class="result-icon result-${icon}"></div><b>${name}</b>${
            address
              ? `<small>${address}</small>`
              : ''
            }`;

          resultDiv.addEventListener('click', () => {
            const latlng = marker.getLatLng();
            map.setView(latlng, 15);
            setTimeout(() => {
              marker.openPopup();
            }, 300);
          });

          searchResults.appendChild(resultDiv);
        });
      }

      searchInput.addEventListener('input', (e) => {
        const text = e.target.value;
        if (text.trim() === '') {
          displayAllPlaces();
          return;
        }

        combinedSearch(text, displaySearchResults);
      });

// Display all locations on page load
      displayAllPlaces();

      L
        .control
        .search({
          sourceData: combinedSearch,
          textPlaceholder: searchPlaceholder,
          initial: false,
          zoom: 15,
          marker: false,
          formatData: function(data) {
            return data;
          },
          filterData: function(text, records) {
            return records;
          },

          propertyName: 'name',

          moveToLocation: function(location, title, map) {
            console.log('moveToLocation');
            const latlng = location.getLatLng();
            const zoom = this.options.zoom || map.getZoom();
            map.setView(latlng, zoom);
            setTimeout(() => {
              location.openPopup();
            }, 300);
          },

          buildTip: function(text, val) {
            var props = val.feature ?. properties || {};
            var name = props.name || text;
            var icon = val
              .feature
              .properties
              .uniqueId
              .startsWith(props.name)
                ? 'area'
                : 'store';
            var address = props.address || '';
            if (name === address) {
              address = '';
            }
            return `<div><div class="result-icon result-${icon}"><b>${name}</b><br><small>${address}</small></div></div>`;
          }
        })
        .on('search:locationfound', function(e) {
          if (e.layer) {
            e.layer.openPopup();
          }
        })
        .addTo(map);
    }).catch((error) => console.error('Error fetching store data:', error));
  }(function waitForStoreLocatorDeps(retriesLeft) {
    if (areMapDependenciesReady()) {
      initStoreLocatorMap();
      return;
    }

    if (retriesLeft <= 0) {
      console.error('Store locator dependencies failed to load', {
        hasLeaflet: typeof window.L !== 'undefined',
        hasFuse: typeof window.Fuse !== 'undefined',
        hasCluster: typeof window.L !== 'undefined' && typeof window.L.markerClusterGroup === 'function',
        hasMapLibreLeaflet: typeof window.L !== 'undefined' && typeof window.L.maplibreGL === 'function',
        hasSearch: typeof window.L !== 'undefined' && typeof window.L.Control !== 'undefined' && typeof window.L.Control.Search !== 'undefined'
      });
      return;
    }

    setTimeout(function() {
      waitForStoreLocatorDeps(retriesLeft - 1);
    }, 100);
  })(100);

  } catch(e) { console.error(e); }
})();
})();
